import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import ItemActions from '../SectionHandler/ItemActions'

const StyledWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	${/* min-height is for equal height of different cols headers with and without right part */''}
	min-height: ${({ theme }) => theme.contentHeaderHeight};
	margin-bottom: 5px;
`
const StyledTitleContainer = styled.div`
	align-self: flex-end;
	font-size: 16px;
	font-weight: normal;
`
const FlexContainer = styled.div`
	display: flex;
	align-items: center;
`

const ContenHeader = ({ title, rightCol, tableActions }) => {
	const rightHeaderItems = tableActions ? <ItemActions actions={tableActions}/> : null
	return(
		<StyledWrapper>
			<StyledTitleContainer>{title}</StyledTitleContainer>
			<FlexContainer>{rightCol}</FlexContainer>
			{rightHeaderItems}
		</StyledWrapper>
	)
}

ContenHeader.propTypes = {
	title: PropTypes.node,
	rightCol: PropTypes.node
}

export default ContenHeader
